import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import jnjLogin from '@/views/jnj/Login.vue'
import { RouterTabRoutes } from 'vue-router-tab'
// contentsLayout
import Frame from '../components/layout/Frame.vue'

// Asynchronous Loading Page Components
const importPage = view => () =>
  import(/* webpackChunkName: "p-[request]" */ `../views/${view}.vue`)

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/jnj',
    name: 'jnjLogin',
    component: jnjLogin
  },
  {
    path: '/main',
    component: Frame,
    children: [
      ...RouterTabRoutes,
      {
        path: '/main',
        name: 'main',
        component: importPage('Home'),
        meta: {
          title: 'Home'
        }
      },
      {
        path: '/OrderSearch',
        name: 'OrderSearch',
        component: importPage('OrderSearch'),
        meta: {
          title: '주문/배송확인'
        }
      },
      {
        path: '/OrderRegister',
        name: 'OrderRegister',
        component: importPage('OrderRegister'),
        meta: {
          title: '제품주문'
        }
      },
      {
        path: '/ComonOrderRegister',
        name: 'ComonOrderRegister',
        component: importPage('ComonOrderRegister'),
        meta: {
          title: '제품주문(공통)'
        }
      },
      {
        path: '/BackOrderSearch',
        name: 'BackOrderSearch',
        component: importPage('BackOrderSearch'),
        meta: {
          title: '백오더 조회'
        }
      },
      {
        path: '/ClientStockSearch',
        name: 'ClientStockSearch',
        component: importPage('ClientStockSearch'),
        meta: {
          title: '거래처별 재고조회'
        }
      },
      {
        path: '/SalesSearch',
        name: 'SalesSearch',
        component: importPage('SalesSearch'),
        meta: {
          title: '매입내역 조회'
        }
      },
      {
        path: '/PersonalInformation',
        name: 'PersonalInformation',
        component: importPage('PersonalInformation'),
        meta: {
          title: '개인정보 처리방침'
        }
      },
      {
        path: '/PersonalInformation_version2',
        name: 'PersonalInformation_version2',
        component: importPage('PersonalInformation_version2'),
        meta: {
          title: '개인정보 처리방침'
        }
      },
      {
        path: '/LogSearch',
        name: 'LogSearch',
        component: importPage('LogSearch'),
        meta: {
          title: '계정별 로그 조회'
        }
      }
    ]
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: importPage('PageNotFound')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
